module.exports = __webpack_public_path__ + "static/SaolText-BookItalic-80e67a875ed5fa79f8fa014a55c4e018.woff";